/**
 * Scroll To Bottom of a Div
 * @param element
 */
export function scrollToBottom(element: HTMLDivElement | Element) {
  element.scroll({ top: element.scrollHeight, behavior: 'smooth' })
}
